<template>
  <div class="demo_wrap">
    <div class="conduct hidden-xs-only">
      <el-row :gutter="20">
        <el-col :span="8">
          <el-card :body-style="{ padding: '0px' }">
            <img src="../../assets/img/experience/experience-bg.jpg" class="image">
            <div class="content">
              <div class="title">已为100+行业企业客户提供产品及服务</div>
              <div class="title_sub">免费试用，您可获得：</div>
              <el-row class="item-row">
                <el-col :span="13"><i class="el-icon-check"></i>专业顾问全程服务和讲解</el-col>
                <el-col :span="11"><i class="el-icon-check"></i>精美礼品一份</el-col>
                <el-col :span="13"><i class="el-icon-check"></i>免费体验全系统流程</el-col>
                <el-col :span="11"><i class="el-icon-check"></i>最新行业信息咨询</el-col>
                <el-col :span="13"><i class="el-icon-check"></i>行业管理建设性方案</el-col>
                <el-col :span="11"><i class="el-icon-check"></i>行业成功客户交流机会</el-col>
              </el-row>
            </div>
          </el-card>
        </el-col>
        <el-col :span="16">
          <el-card :body-style="{ padding: '0px' }">
          <div class="btn-area">
            <el-button type="primary" :class="showOne?'left-btn':'right-btn'" @click="showOne=!showOne">留言咨询</el-button>
            <el-button type="primary" :class="showOne?'right-btn':'left-btn'"  @click="showOne=!showOne">电话咨询</el-button>
          </div>

          <div class="info-area" v-if="showOne">
            <el-input placeholder="姓名" v-model="name" class="item">
              <template slot="prepend"><img src="../../assets/img/experience/xm.svg"/><el-divider direction="vertical" class="vertical-line"></el-divider></template>
            </el-input>
            <el-input placeholder="联系手机" v-model="phone" class="item">
              <template slot="prepend"><img src="../../assets/img/experience/sj.svg"/><el-divider direction="vertical" class="vertical-line"></el-divider></template>
            </el-input>
            <el-input placeholder="公司名称" v-model="company" class="item">
              <template slot="prepend"><img src="../../assets/img/experience/gs.svg"/><el-divider direction="vertical" class="vertical-line"></el-divider></template>
            </el-input>
            <el-input placeholder="需求内容" v-model="remark" class="item" >
              <template slot="prepend"><img src="../../assets/img/experience/xq.svg"/><el-divider direction="vertical" class="vertical-line"></el-divider></template>
            </el-input>
            <div class="item last">
              期待合作方式：
              <el-radio-group  placeholder="" v-model="type">
                <el-radio label="代理商合作">代理商合作</el-radio>
                <el-radio label="区域合作">区域合作</el-radio>
                <el-radio label="行业合作">行业合作</el-radio>
                <el-radio label="最终用户">最终用户</el-radio>
              </el-radio-group>
            </div>
            <div class="item btn-area">
              <el-button class="reset" @click="reset">重置</el-button>
              <el-button type="primary" class="submit" @click="toSubbmit">提交需求</el-button>

            </div>
          </div>
            <div class="info-area2" v-if="!showOne">

              <div class="dianhua">
                <el-row>
                  <el-col :span="6"><img src="../../assets/img/experience/dh-blue.svg" class="image-icon"/></el-col>
                  <el-col :span="18">
                    <div class="up">Comprehensive consultation</div>
                    <div class="down">综合咨询：400-033-9003</div>
                  </el-col>
                </el-row>
                <div class="line"></div>
                <el-row>
                  <el-col :span="6"><img src="../../assets/img/experience/sj-blue.svg" class="image-icon"/></el-col>
                  <el-col :span="18">
                    <div class="up">After-sales consultation</div>
                    <div class="down">售前咨询：13603710470</div>
                  </el-col>
                </el-row>
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>
    <div class="conduct hidden-sm-and-up" >
      <el-row :gutter="20">
        <el-col :span="24">
          <el-card :body-style="{ padding: '0px' }">
            <img src="../../assets/img/experience/experience-bg.jpg" class="image">
            <div class="content">
              <div class="title">已为100+行业企业客户提供产品及服务</div>
              <div class="title_sub">免费试用，您可获得：</div>
              <el-row class="item-row">
                <el-col :span="13"><i class="el-icon-check"></i>专业顾问全程服务和讲解</el-col>
                <el-col :span="11"><i class="el-icon-check"></i>精美礼品一份</el-col>
                <el-col :span="13"><i class="el-icon-check"></i>免费体验全系统流程</el-col>
                <el-col :span="11"><i class="el-icon-check"></i>最新行业信息咨询</el-col>
                <el-col :span="13"><i class="el-icon-check"></i>行业管理建设性方案</el-col>
                <el-col :span="11"><i class="el-icon-check"></i>行业成功客户交流机会</el-col>
              </el-row>
            </div>
          </el-card>
        </el-col>
        <el-col :span="24">
          <el-card :body-style="{ padding: '0px' }">
            <div class="btn-area">
              <el-button type="primary" :class="showOne?'left-btn':'right-btn'" @click="showOne=!showOne">留言咨询</el-button>
              <el-button type="primary" :class="showOne?'right-btn':'left-btn'"  @click="showOne=!showOne">电话咨询</el-button>
            </div>

            <div class="info-area" v-if="showOne">
              <el-input placeholder="姓名" v-model="name" class="item">
                <template slot="prepend"><img src="../../assets/img/experience/xm.svg"/><el-divider direction="vertical" class="vertical-line"></el-divider></template>
              </el-input>
              <el-input placeholder="联系手机" v-model="phone" class="item">
                <template slot="prepend"><img src="../../assets/img/experience/sj.svg"/><el-divider direction="vertical" class="vertical-line"></el-divider></template>
              </el-input>
              <el-input placeholder="公司名称" v-model="company" class="item">
                <template slot="prepend"><img src="../../assets/img/experience/gs.svg"/><el-divider direction="vertical" class="vertical-line"></el-divider></template>
              </el-input>
              <el-input placeholder="需求内容" v-model="remark" class="item" >
                <template slot="prepend"><img src="../../assets/img/experience/xq.svg"/><el-divider direction="vertical" class="vertical-line"></el-divider></template>
              </el-input>
              <div class="item last">
                期待合作方式：
                <el-radio-group  placeholder="" v-model="type">
                  <el-radio label="代理商合作">代理商合作</el-radio>
                  <el-radio label="区域合作">区域合作</el-radio>
                  <el-radio label="行业合作">行业合作</el-radio>
                  <el-radio label="最终用户">最终用户</el-radio>
                </el-radio-group>
              </div>
              <div class="item btn-area">
                <el-button class="reset" @click="reset">重置</el-button>
                <el-button type="primary" class="submit" @click="toSubbmit">提交需求</el-button>

              </div>
            </div>
            <div class="info-area2" v-if="!showOne">

              <div class="dianhua">
                <el-row>
                  <el-col :span="6"><img src="../../assets/img/experience/dh-blue.svg" class="image-icon"/></el-col>
                  <el-col :span="18">
                    <div class="up">Comprehensive consultation</div>
                    <div class="down">综合咨询：400-033-9003</div>
                  </el-col>
                </el-row>
                <div class="line"></div>
                <el-row>
                  <el-col :span="6"><img src="../../assets/img/experience/sj-blue.svg" class="image-icon"/></el-col>
                  <el-col :span="18">
                    <div class="up">After-sales consultation</div>
                    <div class="down">售前咨询：13603710470</div>
                  </el-col>
                </el-row>
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>
    <el-dialog
        title="请输入验证码"
        :visible.sync="captchaDialogVisible"
        width="300px"
        :modal="true"
        :close-on-click-modal="false"
        center>
      <img class="captcha-img" :src="captchaBase64Image" @click="getCaptcha" />
      <el-input class="captcha-input" v-model="captchaCode" placeholder="请输入验证码" />

      <span slot="footer" class="dialog-footer">
      <el-button @click="captchaDialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="onSubmit()" style="background-color: #00A4FF">确 定</el-button>

  </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showOne: true,
      captchaDialogVisible:false,
      name: '',
      phone: '',
      company: '',
      remark: '',
      type: '',
      captchaCode: '',
      captchaUuid: '',
      captchaBase64Image: '',
      refreshCaptchaInterval: null,

    }
  },
  methods: {
    toSubbmit(){
      if(!this.name){
        this.$message({
          message: '<div style="font-size: 0.8rem">请填写姓名</div>',
          type: 'warning',
          dangerouslyUseHTMLString: true,
          customClass: 'custom-message-class'
        });
        return false
      }
      if(!this.phone){
        this.$message({
          message: '<div style="font-size: 0.8rem">请填写联系手机</div>',
          type: 'warning',
          dangerouslyUseHTMLString: true,
          customClass: 'custom-message-class'
        });
        return false
      }
      if(!this.company){
        this.$message({
          message: '<div style="font-size: 0.8rem">请填写公司名称</div>',
          type: 'warning',
          dangerouslyUseHTMLString: true,
          customClass: 'custom-message-class'
        });
        return false
      }
      if(!this.remark){
        this.$message({
          message: '<div style="font-size: 0.8rem">请填写需求内容</div>',
          type: 'warning',
          dangerouslyUseHTMLString: true,
          customClass: 'custom-message-class'
        });
        return false
      }
      if(!this.type){
        this.$message({
          message: '<div style="font-size: 0.8rem">请选择合作方式</div>',
          type: 'warning',
          dangerouslyUseHTMLString: true,
          customClass: 'custom-message-class'
        });
        return false
      }
      this.captchaCode = ''
      this.getCaptcha();
      this.captchaDialogVisible = true;
    },
    getCaptcha() {
      this.axios.get(window.location.origin + '/website-api/login/getCaptcha')
          .then((res) => {
            this.captchaBase64Image = res.data.data.captchaBase64Image;
            this.captchaUuid = res.data.data.captchaUuid;
            this.beginRefreshCaptchaInterval(res.data.data.expireSeconds);
          })
          .catch((err) => {
            console.log(err.message)
          })
    },

    beginRefreshCaptchaInterval(expireSeconds) {
      console.log(expireSeconds,"expireSeconds")
      if (this.refreshCaptchaInterval === null && expireSeconds > 0) {
        this.captchaCode=""
        this.refreshCaptchaInterval = setInterval(this.getCaptcha, (expireSeconds - 5) * 1000);
      }
    },

    stopRefreshCaptchaInterval() {
      if (this.refreshCaptchaInterval != null) {
        clearInterval(this.refreshCaptchaInterval);
        this.refreshCaptchaInterval = null;
      }
    },
    onSubmit() {
      if(!this.captchaCode){
        this.$message({
          message: '验证码不能为空',
          type: 'warning'
        });
        return false
      }
      let fromData = {
        name: this.name,
        phone: this.phone,
        company: this.company,
        remark: this.remark,
        type: this.type,
        captchaCode: this.captchaCode,
        captchaUuid: this.captchaUuid
      }
      this.axios.post(window.location.origin + '/website-api/websiteMessage/add',fromData)
          .then((res) => {
            console.log(res.data)
            if(res.data.code === 0){
              this.$message({
                message: '留言成功，我们将在1到2个工作日内与您联系',
                type: 'success'
              });
              this.centerDialogVisible = false;
              this.captchaDialogVisible = false;
              this.reset()
              this.stopRefreshCaptchaInterval();
            }else{
              this.$message({
                message: res.data.msg,
                type: 'error'
              });
            }
          })
          .catch((err) => {
            console.log(err.message)
          })

    },
    reset() {
      // this.centerDialogVisible = false;
      this.name = '';
      this.phone = '';
      this.company = '';
      this.remark = '';
      this.type = '';
      this.captchaCode = '';
      this.captchaUuid = '';
    },
  },
}
</script>

<style lang="scss" scoped >
.captcha-img{
  width: 100%;
  cursor: pointer;
  margin-bottom: 5px;
}
.custom-message-class {
  font-size: 2rem; /* 调整为你需要的字体大小 */
}
.demo_wrap {
  width: 100%;
  margin-top: 70px;
  .conduct{
    width: 70%;
    margin: auto;
    padding: 50px 0;
    @media screen and (max-width: 768px) {
      width: 95%;
    }
    .content{
      padding: 14px;
      //width: 400px;
      margin: auto;
      height: 310px;
      .title{
        font-size: 20px;
        font-weight: bold;
        margin: 40px auto;
        color: #253554;
        text-align: center;
        letter-spacing: 1px;
      }
      .title_sub{
        font-size: 16px;
        padding-left: 18px;
        margin: 30px auto 20px auto;
        color: #253554;
        text-align: left;
      }
      .item-row{
        font-size: 13px;
        color: #808080;
        padding: 0 18px;
        line-height: 34px;
        i{
          margin-right: 5px;
          color: #0052D9;
          font-weight: bold;
        }
      }
    }
    .btn-area{
      text-align: center;
      width: 100%;
      padding: 40px 10px;
      height: 120px;
      .left-btn{
        width: 48%;
        height: 50px;
        border-radius: 0;
      }
      .right-btn{
        width: 48%;
        height: 50px;
        border-radius: 0;
        background-color: #8491AB;
        border-color: #8491AB;
        &:hover {
          opacity: 0.8;
        }
      }
    }
    .info-area2{
      padding: 40px 10px;
      width: 96%;
      height: 400px;
      margin: auto;
      .dianhua{

        opacity: 1;
        border-radius: 4px;
        background: #FFFFFF;

        border: 1px solid #CCCCCC;

        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        padding: 10px 48px;
        .line {
          border-top: 1px dashed #CCCCCC; /* 或者任何颜色 */
          width: 100%; /* 直线宽度 */
        }
        .image-icon{
          width: 50%;
          margin-top: 28px;
        }
        .up{
          width: 300px;
          color: #999;
          font-size: 14px;
          line-height: 20px;
          margin-top: 20px;
        }
        .down{
          width: 300px;
          color: #666;
          font-size: 24px;
          line-height: 40px;
          margin-bottom: 20px;
          font-weight: bold;
        }
      }
    }
    .info-area{
      padding: 0 40px;
      height: 400px;
      .item{
        margin-bottom: 10px;
        img{
          width: 16px;
          margin-right: 11px;
        }
        .reset{
          padding: 10px;
          width: 160px;
          border-radius: 3px;
          background-color: #CCCCCC;
          color: #fff;
        }
        .submit{
          padding: 10px;
          width: 160px;
          border-radius: 3px;
          background-color: #00A4FF;
        }
        ::v-deep(.el-input__inner){
          border-left: 0 !important;
          height: 50px;
          &:hover{
            border-color:#DCDFE6 ;
          }
          &:focus{
            border-color:#DCDFE6 ;
          }
        }
      }
      .last{
        margin: 20px auto 0px auto;
      }
      .btn-area{
        text-align: center;
      }

    }
    .vertical-line {
      margin-left: 15px;
      height: 18px;
      opacity: 0.7;
      margin-top: -5px;
    }
  }
}

::v-deep(.el-input-group__prepend){
  border-right: 0 !important;
  background-color: #fff;
}
.image {
  width: 100%;
  height: 210px;
  display: block;
}
</style>